import { Space } from "components/Common/Space";
import { Image } from "components/Common/Image";
import { ExerciseHeader } from "components/Common/ExerciseHeader";
import { Paragraph } from "components/Typography/Paragraph";
import {
  TDescribeGifExercise,
  TDescribeGifExercisePayload,
} from "types/app/exercises";
import { TExerciseFileUrl } from "types/api/exercise";
import "./DescribeGif.styles.scss";

type TDescribeGifProps = {
  /**
   * Chapter ID to which the exercise belongs.
   */
  chapterId: number;
  /**
   * An exercise raw data from API response.
   */
  exercise: TDescribeGifExercise;
  /**
   * Lesson chapter order number with the exercise sequence number to display before the exercise condition.
   * @default null
   */
  prefix?: string | null;
};

export const DescribeGif: React.FC<TDescribeGifProps> = (props) => {
  const { chapterId, exercise, prefix = null } = props;

  return (
    <Space direction="vertical" size="medium" justify="start" fullWidth>
      <ExerciseHeader<TDescribeGifExercisePayload & TExerciseFileUrl>
        chapterId={chapterId}
        exercise={exercise}
        prefix={prefix}
      />
      <Image
        src={exercise.payload.data.fileUrl}
        alt="Describe GIF"
        className="nb-exercise-describe-gif-image"
        fullWidth
        rounded
      />
      <Paragraph variant={2}>{exercise.payload.data.description}</Paragraph>
    </Space>
  );
};
